<div
  *ngIf="vm$ | async; let vm"
  [ngStyle]="vm.bgStyles"
  class="background"
  [ngClass]="vm.customClasses"
  [class.radialOverlay]="vm.isRadial"
>
  <ng-content></ng-content>
</div>
